import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import * as manualGuideService from "../../../services/manual-guide.service";
import Breadcrums from "../../../common/breadcrumbs";
import Loader from "../../../common/loader";
import { breakWord, formateDate } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";

// import $ from "jquery";

const GeneralView = (props) => {
  const {t} = useTranslation();
  const loc = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});

  useEffect(() => {
    manualGuideService
      .Details(params.id)
      .then((response) => {
        // console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body p-0">
              <div>
                <span className="main-content-label mb-2 d-block" style={{fontSize:"14px"}}>
                  General
                </span>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>Title</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.title ? showdefault.title : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>Title japanese</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.title_ja ? showdefault.title_ja : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>Breadcrumb title</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.breadcrumb_title ? showdefault.breadcrumb_title : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>Breadcrumb title japanese</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.breadcrumb_title_ja ? showdefault.breadcrumb_title_ja : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>Slug</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.slug ? showdefault.slug : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>Description</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.description ? showdefault.description : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>Description japanese</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.description_ja ? showdefault.description_ja : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneralView;
